import { RootState } from "@/fe-core/meta/types/root";
import { IStatus } from "@/fe-core/meta/interfaces/root";
import { PromotionsState } from "@/fe-core/meta/types/promotions";
import {
  IBottomPromotionsResponsePayload,
  IPromotionsCategoryViewModel,
  IPromotionsViewModel,
  IPromotionViewModel,
} from "@/fe-core/meta/interfaces/promotions";
import { ICasinoGameViewModel } from "@/fe-core/meta/interfaces/casino";

export const promotionsSelector = ({
  promotions,
}: RootState): PromotionsState => promotions;

export const promotionGamesSelector = (
  state: RootState
): {
  pending: { [key: string]: boolean };
  games: { [key: string]: ICasinoGameViewModel[] | null };
} => {
  const { promotionGames } = promotionsSelector(state);

  return promotionGames;
};

export const promotionGamesPendingSelector = (
  state: RootState
): { [key: string]: boolean } => {
  const { pending } = promotionGamesSelector(state);

  return pending;
};

export const promotionGamesDataSelector = (
  state: RootState
): { [key: string]: ICasinoGameViewModel[] | null } => {
  const { games } = promotionGamesSelector(state);

  return games;
};

export const promotionsPendingSelector = (state: RootState): boolean => {
  const { pending } = promotionsSelector(state);

  return pending;
};

export const promotionsStatusSelector = (state: RootState): IStatus | null => {
  const { status } = promotionsSelector(state);

  return status;
};

export const promotionsDataSelector = (
  state: RootState
): IPromotionsViewModel | null => {
  const { data } = promotionsSelector(state);

  let ret: IPromotionsViewModel | null = null;

  if (data) {
    ret = data.filter((promotion) => {
      //@ts-ignore
      return promotion.isHidden !== true;
    });
  }

  return ret;
};

export const promotionsDataByCategorySelector =
  (state: RootState): ((category: string) => IPromotionsViewModel | null) =>
    (category: string): IPromotionsViewModel | null => {
      const { data } = promotionsSelector(state);

      if (!data) {
        return null;
      }

      const promotions: IPromotionsViewModel = [];

      data.forEach((promotion) => {
        //@ts-ignore
        if (!promotion.isHidden) {
          promotion.promotionCategories.forEach((cat) => {
            if (cat.slug === category) {
              promotions.push(promotion);
            }
          });
        }
      });

      return promotions;
    };

export const promotionByCategoryAndSlugSelector =
  (
    state: RootState
  ): ((category: string, slug: string) => IPromotionViewModel | null) =>
    (category: string, slug: string): IPromotionViewModel | null => {
      const { data } = promotionsSelector(state);

      if (!data) {
        return null;
      }

      let promoSelected: IPromotionViewModel | null = null;

      promoSelected =
        data.find(
          (promotion) =>
            promotion.slug === slug &&
            promotion.promotionCategories.filter(
              (categ) => categ.slug === category
            ).length > 0
        ) || null;

      return promoSelected;
    };

export const promotionsCategoriesSelector = (
  state: RootState
): IPromotionsCategoryViewModel[] | null => {
  const { categories } = promotionsSelector(state);

  return categories;
};

export const bottomPromotionDataSelector = (
  state: RootState
): IBottomPromotionsResponsePayload | null => {
  const { bottomPromotionData } = promotionsSelector(state);
  return bottomPromotionData;
};

export const bottomPromotionPendingSelector = (state: RootState): boolean => {
  const { pendingBottomPromotion } = promotionsSelector(state);
  return pendingBottomPromotion;
};

export const bottomPromotionStatusSelector = (state: RootState): IStatus | null => {
  const { bottomPromotionStatus } = promotionsSelector(state);
  return bottomPromotionStatus;
}